import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root',
})

export class UserPermissionsService{
    sessionId: string = "";
    user: string;
    userName: string;
    
    constructor (private http: HttpClient) {
        this.user = sessionStorage.getItem('user');
        this.userName = JSON.parse(this.user).username;
        this.sessionId = localStorage.getItem('sessionId');
    }

    search(payload: any){
        const url = `${environment.apiURL}/admin/user-permissions/search`
        return this.http.post(url,payload , {
            headers: { 'cookie-header': `${this.sessionId}:${this.userName}`}
        });
    }
    
    permissionNames(payload: any){
        const url = `${environment.apiURL}/admin/user-permissions/get-permissions`
        return this.http.post(url, payload, {
            headers : {'cookie-header': `${this.sessionId}:${this.userName}`}
        })
    }                                                                               

    createUserPermissions(payload: any){
        const url = `${environment.apiURL}/admin/user-permissions/add-permissions`
        return this.http.post(url,payload, {
            headers : { 'cookie-header': `${this.sessionId}:${this.userName}` }
        })
    }

    updateUserPermissions(payload: any){
        const url = `${environment.apiURL}/admin/user-permissions/update-permissions`
        return this.http.post(url,payload, {
            headers : { 'cookie-header': `${this.sessionId}:${this.userName}` }
        })
    }

    getDefaultInstructorPermission(){
        const url = `${environment.apiURL}/admin/permissions/get-default-instructor-permissions`
        return this.http.get(url,
            {
                headers: {'cookie-header': `${this.sessionId}:${this.userName}`}
            }
        )
    }

    getDefaultLearnerPermission(){
        const url = `${environment.apiURL}/admin/permissions/get-default-learner-permissions`
        return this.http.get(url,
            {
                headers: {'cookie-header': `${this.sessionId}:${this.userName}`}
            }
        )
    }
}